module.exports = __webpack_public_path__ + "images/home/product/mobile/features-files-aec879dca985748f527b48cd99dee625.png";